import styled from "styled-components";
import { ProductCardStyled } from "../common/components/ProductCard";

export const DashboardContainer = styled.main`
    width: 100%;
`;

export const HeaderSectionWrapper = styled.section`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .catalogue__filter-button-wrap {
        position: relative;
    }
`;

export const CatalogueGridWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 24px;

    @media (max-width: 1165px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 560px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const DashboardLoaderWrap = styled.div`
    position: relative;
`;

export const DeviceCardStyled = styled(ProductCardStyled)`
    gap: 16px;
    cursor: default;
    h4 {
        color: #000;
        font-size: 1.063rem;
        font-style: normal;
        font-weight: 900;
        line-height: 20px;
    }
    .catalogue__content-wrap {
        p {
            word-break: break-all;
            cursor: pointer;
        }
        .catalogue__sales-delete {
            cursor: pointer;
        }
    }
`;
